<template>
  <div>
    <div v-if="!loading">
      <div class="applicant-jobs-container">
        <div v-if="bodyList">
          <FilterJob
            v-on:filterHandler="filterHandler"
            :firstTitle="'Jobs'"
            :secondTitle = "'Type of Employment'"
            :thirdTitle = "'Status'"
            :firstOptions="firstOptions"
            :secondOptions="secondOptions"
            :thirdOptions="thirdOptions"
            :firstSelectedValue="firstSelectedValue"
            :secondSelectedValue="secondSelectedValue"
            :thirdSelectedValue="thirdSelectedValue"
          />
        </div>

        <ListTable
          v-if="!loading && bodyList"
          :headList="headList"
          :bodyList="currentJobsList"
          :emptyStateTitle="emptyStateTitle"
          :emptyListDescription="jobDesc"
          v-on:viewHandler="linkToJobDetails"
        />
      </div>

      <div class="pagination">
        <Pagination
          v-if="bodyList !== null && bodyList.length > 0"
          v-bind:itemsPerPage="itemsPerPage"
          v-bind:totalJobs="bodyList.length"
          v-bind:currentPage="currentPage"
          v-on:paginate="paginate"
        />
      </div>

    </div>

    <div v-if="loading">
      <FilterJob
        v-on:filterHandler="filterHandler"
        :firstTitle="'Jobs'"
        :secondTitle="'Type of Employment'"
        :thirdTitle="'Status'"
        :firstOptions="firstOptions"
        :secondOptions="secondOptions"
        :thirdOptions="thirdOptions"
        :firstSelectedValue="firstSelectedValue"
        :secondSelectedValue="secondSelectedValue"
        :thirdSelectedValue="thirdSelectedValue"
        class="applicant-jobs-container"
      />

      <!-- Loader Component -->
      <div class="loader" v-if="loading">
        <Loader />
      </div>

    </div>
  </div>
</template>

<script>
import ListTable from '../../components/body/ListTable.vue';
import FilterJob from '../../components/body/FilterJob.vue';
import threeDotsIcon from '../../assets/images/tableDots.png';
import Pagination from '../../components/Pagination.vue';
import Loader from '../../components/body/Loader.vue';

export default {
  name: 'ApplicantJobList',
  components: {
    ListTable,
    FilterJob,
    Pagination,
    Loader
  },
  data() {
    return {
      loading: false,
      jobs: null,
      headList: [
        {
          text: 'JOB TITLE',
        },
        {
          text: 'COMPANY',
        },
        {
          text: 'LOCATION',
        },
        {
          text: 'EMPLOYMENT TYPE',
        },
        {
          text: 'STATUS',
        },
        {
          text: 'DEADLINE',
        },
        {
          text: '',
        },
      ],
      bodyList: null,

      emptyStateTitle: 'Jobs',
      jobDesc: 'Jobs Not Available',

      firstOptions: [
        { id: 1, name: 'All Jobs', value: 'allJobs', selected: true },
        { id: 2, name: 'Technology', value: 'Technology' },
        { id: 3, name: 'Education', value: 'Education' },
        { id: 4, name: 'Product Design', value: 'Product Design' },
        { id: 5, name: 'Product Management', value: 'Product Management' },
        { id: 6, name: 'Project Management', value: 'Project Management' },
        { id: 7, name: 'Administration', value: 'Administration' },
        { id: 8, name: 'Operations', value: 'Operations' },
        { id: 9, name: 'Sales', value: 'Sales' },
        { id: 10, name: 'Marketing', value: 'Marketing' },
        { id: 11, name: 'Customer Service', value: 'Customer Service' },
        { id: 12, name: 'Human Resources', value: 'Human Resources' },
        { id: 13, name: 'Creative & Design', value: 'Creative and Design' },
        { id: 14, name: 'Media & Communications', value: 'Media and Communications' },
        { id: 15, name: 'Health & Wellness', value: 'Health and Wellness' },
        { id: 16, name: 'Hospitality & Tourism', value: 'Hospitality and Tourism' },
        { id: 17, name: 'Arts & Entertainment', value: 'Arts and Entertainment' },
        { id: 18, name: 'Science & Research', value: 'Science and Research' },
        { id: 19, name: 'Agriculture', value: 'Agriculture' },
        { id: 20, name: 'Finance', value: 'Finance' },
        { id: 21, name: 'Supply Chain', value: 'Supply Chain' },
        { id: 22, name: 'Engineering', value: 'Engineering' },
        { id: 23, name: 'Building & Construction', value: 'Building and Construction' },
        {
          id: 24,
          name: 'Logistics & Transportation',
          value: 'Logistics and Transportation',
        },
        { id: 25, name: 'Legal', value: 'Legal' },
        { id: 26, name: 'Energy & Utilities', value: 'Energy and Utilities' },
        { id: 27, name: 'Telecommunications', value: 'Telecommunications' },
        {
          id: 28,
          name: 'Petroleum & Petrochemicals',
          value: 'Petroleum and Petrochemicals',
        },
        {
          id: 29,
          name: 'Furniture & Interior Design',
          value: 'Furniture and Interior Design',
        },
        { id: 30, name: 'Manufacturing', value: 'Manufacturing' },
        { id: 31, name: 'Healthcare', value: 'Healthcare' },
        { id: 32, name: 'Others', value: 'Others' },
      ],
      secondOptions: [
        { id: 1, name: 'All Employment Types', value: 'allEmployment', selected: true },
        { id: 2, name: 'Full Time', value: 'Full Time' },
        { id: 3, name: 'Full Time - Remote', value: 'Full Time - Remote' },
        { id: 4, name: 'Full Time - Hybrid', value: 'Full Time - Hybrid' },
        { id: 5, name: 'Part Time', value: 'Part Time' },
        { id: 6, name: 'Part Time - Remote', value: 'Part Time - Remote' },
        { id: 7, name: 'Part Time - Hybrid', value: 'Part Time - Hybrid' },
        { id: 8, name: 'Contract', value: 'Contract' },
        { id: 9, name: 'Contract - Remote', value: 'Contract - Remote' },
        { id: 10, name: 'Contract - Hybrid', value: 'Contract - Hybrid' },
        { id: 11, name: 'Internship', value: 'Internship' },
      ],
      thirdOptions: [
        {id: 1, name: 'All Status', value: 'allStatus', selected: true},
        {id: 2, name: 'Active', value: 'Active' },
        {id: 3, name: 'Expired', value: 'Expired' },
      ],
      firstSelectedValue: 'allJobs',
      secondSelectedValue: 'allEmployment',
      thirdSelectedValue: 'allStatus',
      threeDotsIcon,

      currentPage: 1,
      itemsPerPage: 15,
    };
  },
  async mounted() {
    await this.getPosts();
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },

    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },

    currentJobsList() {
      return this.bodyList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
  },
  methods: {
    // Get all Job posts and set the table headList and body list
    getPosts() {
      this.loading = true;
      this.$store
          .dispatch('getAllPosts')
          .then((res) => {
            if (res.response) {
              this.bodyList = [];
              this.jobs = [];
              let results = this.$store.state.allPosts;
              results.reverse().forEach((job) => {

                // Check that Job is active and return only active jobs.
                if (!job.jobDeadline || new Date(job.jobDeadline) > Date.now()) {

                  // Modify each job to suit table
                  let body = {
                    jobTitle: job.title,
                    company: job.companyName ? job.companyName : '—',
                    location:
                    job.city && job.state ? `${job.city}, ${job.state}` : '—',
                    employmentType: job.employmentType ? job.employmentType : '—',
                    category: job.category,
                    status:
                    !job.jobDeadline || new Date(job.jobDeadline + 'T00:00:00') > Date.now()
                      ? 'Active'
                      : 'Expired',
                    deadline:
                    job.jobDeadline.trim() === ''
                      ? '—'
                      : new Date(job.jobDeadline + 'T00:00:00').toDateString(),
                    threeDotsIcon: threeDotsIcon,
                    id: job.id,
                  };

                  this.bodyList.push(body);
                  this.jobs.push(body);
                }
              });

              this.loading = false;

              // eslint-disable-next-line no-sequences
              return this.bodyList, this.jobs, this.headList;

            } else {
              this.bodyList = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$toastr.error(
              err.error.error ? err.error.error
              :err.error ? err.error.errorMessage
              :err.error,
              'Failed'
            );
          });
    },
    linkToJobDetails(jobId) {
      this.$emit('setJobId', jobId);
    },
    filterHandler(selectedOptions) {
      this.currentPage = 1;

      // Ensure jobList is initialized
      if (!this.jobList || this.jobList.length === 0) {
        this.jobList = [...this.jobs];
      }

      const { firstOption, secondOption, thirdOption } = selectedOptions;

      // Start with all jobs
      let result = [...this.jobs];

      // --- CATEGORY FILTER ---
      if (firstOption && firstOption !== 'allJobs') {
        result = result.filter(job => job.category === firstOption);
      }

      // --- EMPLOYMENT TYPE FILTER ---
      if (secondOption && secondOption !== 'allEmployment') {
        result = result.filter(job => job.employmentType === secondOption);
      }

      // --- STATUS FILTER ---
      if (thirdOption && thirdOption !== 'allStatus') {
        result = result.filter(job => job.status === thirdOption);
      }

      // Update the displayed list
      this.bodyList = result;

      return result;
    },
    // Dynamic Multi-Select Filter Handlers
    multiFilterHandler(selectedOptions) {
      this.currentPage = 1;

      // Ensure jobList is initialized
      if (!this.jobList || this.jobList.length === 0) {
        this.jobList = [...this.jobs];
      }

      // Map filter keys to job fields and their "all" values
      const filterConfig = {
        firstOption: { field: 'category', allValue: 'allJobs' },
        secondOption: { field: 'employmentType', allValue: 'allEmployment' },
        thirdOption: { field: 'status', allValue: 'allStatus' }
      };

      // Start with all jobs
      let result = [...this.jobs];

      // Apply all filters dynamically
      for (const [optionKey, config] of Object.entries(filterConfig)) {
        const selectedValue = selectedOptions[optionKey];

        if (!selectedValue) continue; // skip null/undefined/empty

        // Support multi-select (array) or single value
        const valuesToFilter = Array.isArray(selectedValue) ? selectedValue : [selectedValue];

        // Skip if it contains only the "all" value
        if (valuesToFilter.includes(config.allValue)) continue;

        // Apply filter
        result = result.filter(job => valuesToFilter.includes(job[config.field]));
      }

      this.bodyList = result;
      return result;
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    },
  },
};
</script>
<style scoped>
  .applicant-jobs-container {
    background: var(--white);
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    box-sizing: border-box;
    box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
    border-radius: 10px 10px;
  }
  .pagination {
    margin-top: 30px;
    display: flex;
    justify-content: right;
    align-items: center;
  }
</style>
